// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__AKh26","bookNowBtnStyle":"AboutUs_bookNowBtnStyle__LePbK"};